//#region IMPORT
import React, { useEffect, useState, useRef } from 'react';
import M_TBG_CUSTOM_08 from './M_TBG_CUSTOM_08';
import { useDispatch, useSelector } from 'react-redux';
import { M_TBG_CUSTOM_08_Schema } from './M_TBG_CUSTOM_08_Schema';
import { useSave1, useSave2, useSave3 } from './M_TBG_CUSTOM_08_Query';
import { useSave } from '../../../../Hooks/useSave';
import useFileUpload from '../../../../Hooks/useFileUpload';
import { CommonActions } from '../../../../Reducer/CommonReducer';
// useBackStack 임포트
import { useBackStack } from '../../../../Hooks/back/useBackStack';
//#endregion

const MAX_PHOTOS = 1;

function M_TBG_CUSTOM_08F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const activeStep = useSelector((state) => state.common.activeStep);

  // 최신 activeStep 참조용 ref
  const activeStepRef = useRef(activeStep);
  useEffect(() => {
    activeStepRef.current = activeStep;
  }, [activeStep]);

  const [inputs, setInputs] = useState({
    tbmTitle: '',
    tbmComment: '',
    tbmAddress: '',
    photoNm: '',
    photoImg: null,
    photoSrc: '',
  });
  const signatureCanvas = useRef(null);
  const [signInputs, setSignInputs] = useState({ mapUrl: '', mapFiles: {} });

  const tbmUpload = useFileUpload({
    oldFilePathField: 'tbmPhoto',
    newFileNameField: 'saveName',
    getTargetPath: () => `TBM/${props.tbmCdRef.current}/Photo`,
    maxCount: MAX_PHOTOS,
  });
  const signUpload = useFileUpload({
    oldFilePathField: 'signPath',
    newFileNameField: 'saveName',
    getTargetPath: () => `TBM/${props.tbmCdRef.current}/Sign`,
  });
  //#endregion

  // 뒤로가기 핸들러 수정
  useBackStack({
    type: 'custom',
    onBack: () => {
      const rollbackStep = props.addMeetingFlag ? 1 : 2;
      dispatch(
        CommonActions.setActiveStep(activeStepRef.current - rollbackStep)
      );
    },
  });

  //#region 이벤트
  useEffect(() => {
    return () => {
      tbmUpload.clearFiles();
      signUpload.clearFiles();
    };
  }, []);

  useEffect(() => {
    const list = (tbmUpload.previewList ?? []).filter((img) => !img.deleted);
    setInputs((prev) => {
      if (list.length === 0) {
        return { ...prev, photoNm: '', photoSrc: '', photoImg: null };
      }
      const first = list[0];
      return {
        ...prev,
        photoNm: first.fileName || first.saveName || '',
        photoSrc: first.preview || '',
        photoImg: null,
      };
    });
  }, [tbmUpload.previewList]);
  //#endregion

  //#region 쿼리 (기존 로직 유지)
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();
  const { runAsync: Save3Async } = useSave3();

  const { run: Save1 } = useSave({
    menuId: 'M_TBG_CUSTOM_08',
    schema: M_TBG_CUSTOM_08_Schema,
    fileSave: async () => {
      const finalPath = await tbmUpload.SaveLogicFile();
      const signFinalPath = await signUpload.SaveLogicFile();
      return { tbmPhoto: finalPath, signPath: signFinalPath };
    },
    saveData: () => ({
      tbmCd: props.tbmCdRef.current,
      tbmTitle: inputs.tbmTitle,
      tbmComment: inputs.tbmComment,
      tbmAddress: inputs.tbmAddress,
    }),
    requestSave: (rows) => Save1Async(rows),
    onSuccess: (rows) => {
      Save2Async([{ tbmCd: props.tbmCdRef.current }]);
      Save3Async([{ eStep: '5', mStep: '8', tbmCd: props.tbmCdRef.current }]);
      dispatch(CommonActions.setActiveStep(activeStepRef.current + 1));
      props.ActiveButton({
        type: 'end',
        content: true,
        waiting: 'N',
      });
      tbmUpload.clearFiles();
      signUpload.clearFiles();
    },
  });
  //#endregion

  return (
    <M_TBG_CUSTOM_08
      MAX_PHOTOS={MAX_PHOTOS}
      inputs={inputs}
      setInputs={setInputs}
      tbmUpload={tbmUpload}
      signUpload={signUpload}
      SaveLogic1={Save1}
      ActiveButton={props.ActiveButton}
      signatureCanvas={signatureCanvas}
      signInputs={signInputs}
      setSignInputs={setSignInputs}
      userInfo={userInfo}
    />
  );
}

export default M_TBG_CUSTOM_08F;
